<div class="content">
    <div class="containerShipment accordion" id="accordionExample">
        <div class="accordion-item">
            <h2 class="accordion-header" id="headingOne">
                <button class="accordion-button titleShipment" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    <i class="icon-filters"></i> <span *ngIf="filtersActive"
                        class="translate-middle  bg-danger rounded-circle"></span>
                    {{ 'shipment.titleFilters' | translate }}
                </button>
            </h2>
            <div id="collapseOne" class="accordion-collapse collapse" [ngClass]="{'show': showCollapse}"
                aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                <div class="accordion-body">
                    <form [formGroup]="formFilters" class="row g-4" style="padding: 1.5rem;">
                        <div class="col-3  input-group">
                            <input class="form-control datepicker" placeholder="{{ 'shipment.selectDate' | translate }}"
                                angular-mydatepicker name="dateFilter" formControlName="dateFilter"
                                [options]="myDatePickerOptions" (click)="dp.toggleCalendar()"
                                #dp="angular-mydatepicker" />
                            <span class="input-group-btn">
                                <button type="button" class="btn btn-calendar" (click)="dp.clearDate()"><i
                                        class="icon-cross"></i></button>
                                <button type="button" class="btn btn-calendar2" (click)="dp.toggleCalendar()"><i
                                        class="icon-calendar"></i></button>
                            </span>
                        </div>
                        <div class="col-3">
                            <input type="text" class="form-control"
                                placeholder="{{ 'shipment.shipmentNumber' | translate }}" aria-label="Shipment number"
                                formControlName="shipment_num">
                        </div>
                        <div class="col-3">
                            <input type="text" class="form-control" placeholder="MAW" aria-label="MAW"
                                formControlName="statusSelect">
                        </div>
                        <div class="col-3">
                            <select class="form-select" name="country" id="countrySelect"
                                formControlName="countrySelect">
                                <option value="" disabled selected>{{ 'shipment.country' | translate }}</option>
                                <option [value]="country.cpai" *ngFor="let country of countries">{{country.description}}</option>
                            </select>
                        </div>
                        <div class="col-12 colButtonsForm float-end">
                            <hr>
                            <button class="btn btn-secondary btnReset" type="reset" (click)="resetFilters()">{{
                                'shipment.reset' | translate }}</button>
                            <button class="btn btn-primary btnApply" [disabled]="!formFilters.valid"
                                (click)="search()">{{ 'shipment.apply_filters' | translate }}</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <h2 *ngIf="filtersActive" class="titleTable">{{ 'shipment.shipmentTitle' | translate }}</h2>
    <br>
    <div class="containerDataTable" style="width: auto; overflow-y:scroll;">
        <img *ngIf="!filtersActive" class="imgDataTable" src="assets/images/shipments.svg" alt="">
        <table id="shipmentDataTable" *ngIf="filtersActive" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table row-border hover nowrap"> 
            <thead>
                <tr class="tableHeader">
                    <th>{{ 'userManagement.actions' | translate }}</th>
                    <th>{{ 'columns.shipmentNumber' | translate }}</th>
                    <th>{{ 'columns.csac' | translate }}</th>
                    <th>{{ 'columns.cnCode' | translate }}</th>
                    <th>{{ 'columns.goodsDescriptionPl' | translate }}</th>
                    <th>{{ 'columns.instrinicValueEur' | translate }}</th>
                    <th>{{ 'columns.noOfGoods' | translate }}</th>
                    <th>{{ 'columns.wieghtsNet' | translate }}</th>
                    <th>{{ 'columns.grossMass' | translate }}</th>
                    <th>{{ 'columns.originOfGoods' | translate }}</th>
                    <th>{{ 'columns.destination' | translate }}</th>
                    <th>{{ 'columns.b2cB2b' | translate }}</th>
                    <th>{{ 'columns.dateSendEns' | translate }}</th>
                    <th>{{ 'columns.conex' | translate }}</th>
                    <th>{{ 'columns.controlEns' | translate }}</th>
                    <th>{{ 'columns.dateOfArrival' | translate }}</th>
                    <th>{{ 'columns.arnConex' | translate }}</th>
                    <th>{{ 'columns.status' | translate }}</th>
                    <th>{{ 'columns.huzard' | translate }}</th>
                    <th>{{ 'columns.controlH7' | translate }}</th>
                    <th>{{ 'columns.typeDeclaration' | translate }}</th>
                    <th>{{ 'columns.otherClearences' | translate }}</th>
                    <th>{{ 'columns.packetStatus' | translate }}</th>
                    <th>{{ 'columns.legalDocInvoice' | translate }}</th>
                    <th>{{ 'columns.surnameBuyer' | translate }}</th>
                    <th>{{ 'columns.streetBuyer' | translate }}</th>
                    <th>{{ 'columns.postalNoBuyer' | translate }}</th>
                    <th>{{ 'columns.cityBuyer' | translate }}</th>
                    <th>{{ 'columns.countryBuyer' | translate }}</th>
                    <th>{{ 'columns.seller' | translate }}</th>
                    <th>{{ 'columns.streetSeller' | translate }}</th>
                    <th>{{ 'columns.postalNoSeller' | translate }}</th>
                    <th>{{ 'columns.citySeller' | translate }}</th>
                    <th>{{ 'columns.countrySeller' | translate }}</th>
                    <!-- <th>{{ 'columns.tinNumber' | translate }}</th> -->
                    <th>{{ 'columns.PacketStatusUpdated' | translate }}</th>
                    <th>{{ 'columns.annotations' | translate }}</th>

                    <!--
                    <th> {{ 'columns.cacesaIalb' | translate }}</th>
                    <th> {{ 'columns.goodsDescriptionEn' | translate }}</th>
                    <th class="none">{{ 'columns.cmansal' | translate }}</th>
                    <th class="none">{{ 'columns.controlResultEns' | translate }}</th>
                    <th class="none">{{ 'columns.controlResultH7' | translate }}</th>
                    <th class="none">{{ 'columns.dateHuzardProcessStatus' | translate }}</th>
                    <th class="none">{{ 'columns.dateInsert' | translate }}</th>
                    <th class="none">{{ 'columns.dateMod' | translate }}</th>
                    <th class="none">{{ 'columns.email' | translate }}</th>
                    <th class="none">{{ 'columns.fmansal' | translate }}</th>
                    <th class="none">{{ 'columns.hourMod' | translate }}</th>
                    <th class="none">{{ 'columns.huzardProcessStatus' | translate }}</th>
                    <th class="none">{{ 'columns.id' | translate }}</th>
                    <th class="none">{{ 'columns.instrinicValuePln' | translate }}</th>
                    <th class="none">{{ 'columns.iossTransactionNo' | translate }}</th>
                    <th class="none">{{ 'columns.ncifdes' | translate }}</th>
                    <th class="none">{{ 'columns.nmaw' | translate }}</th>
                    <th class="none">{{ 'columns.npda' | translate }}</th>
                    <th class="none">{{ 'columns.transportationCostEur' | translate }}</th>
                    <th class="none">{{ 'columns.transportationCostPln' | translate }}</th>
                    <th class="none">{{ 'columns.userInsert' | translate }}</th>
                    <th class="none">{{ 'columns.userMod' | translate }}</th>
                    <th class="none">{{ 'columns.vatEur' | translate }}</th>
                    <th class="none">{{ 'columns.vatPln' | translate }}</th>
                    <th class="none">{{ 'columns.vatRate' | translate }}</th>
                    <th class="none">{{ 'columns.vdutpln' | translate }}</th> -->
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let shipment of data;let i = index">
                    <td class="text-center">
                        <button class="btn btnEdit" id="buttonEditShipment" (click)="openEdit(shipment, i)"><i class="icon-edit"></i></button>
                        <button class="btn btnEdit" id="buttonShowAudit" (click)="openAudit(shipment)"><i class="icon-eye"></i></button>
                    </td>
                    <td>{{ shipment.shipmentNumber }}</td>
                    <td>{{ shipment.csac }}</td>
                    <td>{{ shipment.cnCode }}</td>
                    <td>{{ shipment.goodsDescriptionPl }}</td>
                    <td>{{ shipment.instrinicValueEur }}</td>
                    <td>{{ shipment.noOfGoods }}</td>
                    <td>{{ shipment.wieghtsNet }}</td>
                    <td>{{ shipment.grossMass }}</td>
                    <td>{{ shipment.originOfGoods }}</td>
                    <td>{{ shipment.countryBuyer }}</td>
                    <td>{{ shipment.b2cB2b }}</td>
                    <td>{{ shipment.dateSendEns | date :'dd/MM/YYYY hh:mm a' }}</td>
                    <td>{{ shipment.conex }}</td>
                    <td><span class="pill pill-{{ shipment.controlEns | lowercase }}">{{ shipment.controlEns | uppercase }}</span></td>
                    <td>{{ shipment.dateOfArrival | date :'dd/MM/YYYY hh:mm a' }}</td>
                    <td>{{ shipment.arnConex }}</td>
                    <td>{{ shipment.status }}</td>
                    <td>{{ shipment.huzard }}</td>
                    <td><span class="pill pill-{{ shipment.controlH7 | lowercase }}">{{ shipment.controlH7 | uppercase }}</span></td>
                    <td>{{ shipment.typeDeclaration }}</td>
                    <td>{{ shipment.otherClearences }}</td>
                    <td>{{ shipment.packetStatus }}</td>
                    <td>{{ shipment.legalDocInvoice }}</td>
                    <td>{{ shipment.surnameBuyer }}</td>
                    <td>{{ shipment.streetBuyer }}</td>
                    <td>{{ shipment.postalNoBuyer }}</td>
                    <td>{{ shipment.cityBuyer }}</td>
                    <td>{{ shipment.countryBuyer }}</td>
                    <td>{{ shipment.seller }}</td>
                    <td>{{ shipment.streetSeller }}</td>
                    <td>{{ shipment.postalNoSeller }}</td>
                    <td>{{ shipment.citySeller }}</td>
                    <td>{{ shipment.countrySeller }}</td>
                    <!-- <td>{{ shipment.tinNumber }}</td> -->
                    <td>{{ shipment.packetStatusUpdated }}</td>
                    <td>{{ shipment.annotations }}</td>
                
                    <!--
                    <td>{{ shipment.cacesaIalb }}</td>
                    <td>{{ shipment.goodsDescriptionEn }}</td>
                    <td>{{ shipment.cmansal }}</td>
                    <td>{{ shipment.controlResultEns }}</td>
                    <td>{{ shipment.controlResultH7 }}</td>
                    <td>{{ shipment.dateHuzardProcessStatus | date :'dd/MM/YYYY hh:mm a' }}</td>
                    <td>{{ shipment.dateInsert | date :'dd/MM/YYYY hh:mm a' }}</td>
                    <td>{{ shipment.dateMod | date :'dd/MM/YYYY hh:mm a' }}</td>
                    <td>{{ shipment.email }}</td>
                    <td>{{ shipment.fmansal | date :'dd/MM/YYYY hh:mm a' }}</td>
                    <td>{{ shipment.hourMod }}</td>
                    <td>{{ shipment.huzardProcessStatus }}</td>
                    <td>{{ shipment.id }}</td>
                
                    <td>{{ shipment.instrinicValuePln }}</td>
                    <td>{{ shipment.iossTransactionNo }}</td>
                    <td>{{ shipment.ncifdes }}</td>
                    <td>{{ shipment.nmaw }}</td>
                    <td>{{ shipment.npda }}</td>
                
                    <td>{{ shipment.transportationCostEur }}</td>
                    <td>{{ shipment.transportationCostPln }}</td>
                    <td>{{ shipment.userInsert }}</td>
                    <td>{{ shipment.userMod }}</td>
                    <td>{{ shipment.vatEur }}</td>
                    <td>{{ shipment.vatPln }}</td>
                    <td>{{ shipment.vatRate }}</td>
                    <td>{{ shipment.vdutpln }}</td> -->
                </tr>
            </tbody>
        </table>
    </div>
    <app-modal #modal [modalConfig]="modalConfig">
        <form *ngIf="!modalAudit" [formGroup]="formEdit">
            <div class="row">
                <div class="col-6">
                    <div class="formField mb-3">
                        <select class="form-select modalInput" name="ctrl_ens" id="ctrl_ens" formControlName="ctrl_ens">
                            <option [value]="item.description.toUpperCase()" *ngFor="let item of ctrl_ens">
                                {{item.description}}
                            </option>
                        </select>
                        <label alt="ctrl_ens" for="ctrl_ens" class="labelForm">{{ 'columns.controlEns' | translate }}</label>
                    </div>
                </div>
                <div class="col-6">
                    <div class="formField mb-3">
                        <select class="form-select modalInput" name="ctrl_ens_result" id="ctrl_ens_result"
                            formControlName="ctrl_ens_result">
                            <option [value]="item.description.toUpperCase()" *ngFor="let item of ctrl_ens_result">
                                {{item.description}}
                            </option>
                        </select>
                        <label alt="ctrl_ens_result" for="ctrl_ens_result" class="labelForm">{{ 'columns.controlResultEns' | translate }}</label>
                    </div>
                </div>
                <div class="col-6">
                    <div class="formField mb-3">
                        <select class="form-select modalInput" name="controlH7" id="controlH7"
                            formControlName="controlH7">
                            <option [value]="item.description.toUpperCase()" *ngFor="let item of ctrl_h7">
                                {{item.description}}
                            </option>
                        </select>
                        <!--  <input type="text" class="form-control modalInput" formControlName="controlH7"> -->
                        <label alt="controlH7" for="controlH7" class="labelForm">{{ 'columns.controlH7' | translate }}</label>
                    </div>
                </div>
                <div class="col-6">
                    <div class="formField mb-3">
                        <select class="form-select modalInput" name="packetStatusUpdated" id="packetStatusUpdated"
                            formControlName="packetStatusUpdated">
                            <option [value]="item.description.toUpperCase()" *ngFor="let item of packet_StatusUpdated">
                                {{item.description}}
                            </option>
                        </select>
                        <!--  <input type="text" class="form-control modalInput" formControlName="controlH7"> -->
                        <label alt="packetStatusUpdated" for="packetStatusUpdated" class="labelForm">{{ 'columns.PacketStatusUpdated' | translate }}</label>
                    </div>
                </div>
                <div class="col-12 pb-4">
                    <div class="formField mb-3">
                        <textarea type="text" class="form-control modalInput" formControlName="comments">  </textarea>
                        <label alt="comments" for="comments" class="labelForm">{{ 'shipment.comments' | translate }}</label>
                    </div>
                </div>
                <div class="col-12 pt-4 pb-2 colButtonForm">
                    <button type="submit" class="btn btnModalConfirm btn-primary float-end" (click)="editShipment()"
                        [disabled]="!formEdit.valid">{{ 'shipment.edit' | translate }}</button>
                </div>
            </div>
        </form>
        <div *ngIf="modalAudit" class="pb-4">
            <table id="auditDataTable" datatable [dtOptions]="dtOptionsAudit" class="table row-border hover">
                <thead>
                    <tr>
                        <th> {{ 'columns.controlResultEnsOld' | translate }}</th>
                        <th> {{ 'columns.controlResultEnsNew' | translate }}</th>
                        <th> {{ 'columns.controlEnsOld' | translate }}</th>
                        <th> {{ 'columns.controlEnsNew' | translate }}</th>
                        <th> {{ 'columns.controlH7Old' | translate }}</th>
                        <th> {{ 'columns.controlH7New' | translate }}</th>
                        <th> {{ 'columns.annotationsOld' | translate }}</th>
                        <th> {{ 'columns.annotationsNew' | translate }}</th>
                        <th> {{ 'columns.User' | translate }} </th>
                        <th> {{ 'columns.dateUpdate' | translate }}</th>
                        <th> {{ 'columns.hourUpdate' | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let audit of auditData">
                        <td> {{ audit.controlResultEnsOld }}</td>
                        <td> {{ audit.controlResultEnsNew }}</td>
                        <td><span class="pill pill-{{audit.controlEnsOld | lowercase}}">{{ audit.controlEnsOld | uppercase }}</span></td>
                        <td><span class="pill pill-{{audit.controlEnsNew | lowercase}}">{{ audit.controlEnsNew | uppercase }}</span></td>
                        <td> {{ audit.controlH7Old }}</td>
                        <td> {{ audit.controlH7New }}</td>
                        <td> {{ audit.annotationsOld }}</td>
                        <td> {{ audit.annotationsNew }}</td>
                        <td> {{ audit.userUpdate }}</td>
                        <td> {{ audit.dateUpdate | date :'dd/MM/YYYY' }}</td>
                        <td> {{ audit.dateUpdate | date :'hh:mm a' }}</td>
                    </tr>
                    <!--  <tr *ngIf="auditData.length==0">
                        <td colspan="11">NOT DATA </td>
                    </tr> -->
                </tbody>
            </table>
        </div>
    </app-modal>
    <!--   <app-audit #audit></app-audit> -->
</div>